/** @jsx jsx */

import React, { useMemo } from "react";
import { jsx } from "@emotion/core";
import { Card, Typography, Icon } from "antd";

import useEligibilityDetails from "../../../hooks/eligibility/useEligibilityDetails";

import { accountDetailsContents as CONSTANTS } from "./AccountDetailsCardConstants";
import { accountDetailsCardStyles } from "./AccountDetailsCardStyles";

const { Text } = Typography;

const AccountDetailsCard: React.FC = () => {
  const {
    eligibilityState: { loading, eligibilityDetails }
  } = useEligibilityDetails();

  const { accountNumber, ifscCode, bankName } = useMemo(() => {
    const disbursalBankAccount = eligibilityDetails?.disbursalBankAccount;
    return {
      accountNumber: disbursalBankAccount?.accountNumber || "",
      ifscCode: disbursalBankAccount?.ifscCode || "",
      bankName: disbursalBankAccount?.bankName || ""
    };
  }, [eligibilityDetails]);

  const renderBankData = (iconType: string, key: string, value: string) => (
    <section className="d-flex align-items-center mt-4">
      <Icon type={iconType} theme="outlined" />
      <section className="d-flex flex-column pl-3">
        <Text className="detail-key">{key}</Text>
        <Text className="detail-value">{value}</Text>
      </section>
    </section>
  );

  return (
    <Card bordered={false} loading={loading} css={accountDetailsCardStyles}>
      <Text className="home-card-title d-block">
        {CONSTANTS.labels.disbursalAccountDetails}
      </Text>
      <div className="d-flex flex-column mb-4">
        {renderBankData("bank", CONSTANTS.labels.bankName, bankName)}
        {renderBankData("swap", CONSTANTS.labels.IFSC, ifscCode)}
        {renderBankData(
          "number",
          CONSTANTS.labels.accountNumber,
          accountNumber
        )}
      </div>
      <Text className="pt-4 instruction-text">
        {CONSTANTS.labels.instruction}
      </Text>
    </Card>
  );
};

export default AccountDetailsCard;
